import { memo } from "react";
import { Alert } from "react-bootstrap";

type AlertComponentsProps = {
  heading?: string;
  message: string;
  variant: string;
  onClose: () => void;
  fixedTop?: boolean;
};

const AlertComponent = ({
  heading,
  message,
  variant,
  onClose,
  fixedTop,
}: AlertComponentsProps) => {
  return (
    <Alert
      style={
        fixedTop
          ? {
              position: "absolute",
              width: "100%",
              zIndex: 100,
            }
          : {}
      }
      show={variant.length > 0 ? true : false}
      variant={variant}
      dismissible
      onClose={() => onClose()}
    >
      {heading && <Alert.Heading>{heading}</Alert.Heading>}
      {message}
    </Alert>
  );
};

export default memo(AlertComponent);
